import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { lineItem, ReorderPointViewModel } from "./reorderPoint-viewModel"

export class ReorderPointView extends View<ReorderPointViewModel>{
    GetViewUniqueId(): string {
        return "V-44C0B31D-0011-4E83-AEBE-E9E3F85C2A89"
    }
    loadHtml(): string {
        let element = require('./reorderPoint.html').default;
        let style = require('./reorderPoint.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    
}
